module.exports = __webpack_public_path__ + "img/cacc-welding.0698590a.jpg";